import { IKeyValue } from 'shared/utils';

export interface IListagemWorkflow {
  CodigoOrganizacao: number;
  IdWorkflow: number;
  NomeWorkflow: string;
  DescricaoWorkflow: string;
  StatusWorkflow: string;
  TipoWorkflow: string;
  DhLiberadoEnvio: string;
  DhPeriodoInicio: string;
  DhPeriodoFim: string;
  DhProximaExecucao: string;
  IdUsuarioInclusao: number;
  DhInclusao: string;
  IdUsuarioAlteracao: number;
  DhAlteracao: number;
  ViewPortX: number;
  ViewPortY: number;
  ViewPortZoom: number;
}

export interface IResponseWorkflow {

  rows: IListagemWorkflow[];
  count: number;

}

export interface IListagemLogWorkflow {
  IdWorkflow: number;
  NomeWorkflow: string;
  StatusWorkflow: string;
  TipoWorkflow: string;
  DhLog: Date;
  NomeUsuarioIns: string;
  NomeUsuarioUpd: string;
  WRKFLOG_ACAO: string;
  USU_ID_LOG:number;
  USU_NM_LOG: string;
  ROW_NUM: number;

}

export interface IResponseLogWorkflow {

  rows: IListagemLogWorkflow[];
  count: number;

}
export interface IDetalheWorkflow {
  CodigoOrganizacao: number;
  IdWorkflow: number;
  NomeWorkflow: string;
  DescricaoWorkflow: string;
  StatusWorkflow: string;
  TipoWorkflow: string;
  DhLiberadoEnvio: Date;
  DhPeriodoInicio: Date;
  DhPeriodoFim: Date;
  DhProximaExecucao: Date | null;
  IdUsuarioInclusao: number;
  NomeUsuarioIns: string;
  DhInclusao: string;
  IdUsuarioAlteracao?: number;
  NomeUsuarioUpd: string;
  DhAlteracao?: Date;
  ViewPortX: number;
  ViewPortY: number;
  ViewPortZoom: number;
}

export interface ICreateWorkflow {
  NomeWorkflow?: string;
  DescricaoWorkflow?: string;
  StatusWorkflow?: string;
  TipoWorkflow?: string;
  DhLiberadoEnvio?: Date;
  DhPeriodoInicio?: Date;
  DhPeriodoFim?: Date;
  DhProximaExecucao?: Date | null;
  ViewPortX?: number;
  ViewPortY?: number;
  ViewPortZoom?: number;
}

export interface IRespFluxoValidacao {
  resultado: string;
  descricao: string;
  erros: Erro[];

}

export interface Erro {
  tipoErro: string;
  componente: string;
  tipoComponente: string;
  idComponente: string;
  nomeComponente: string;
  handleSource: string;
  handleTarget: string;
  codErro: number;
  dsErro: string;
}

export const InicitalCreateWorkflow = {
  NomeWorkflow: '',
  DescricaoWorkflow: '',
  StatusWorkflow: 'INAT ',
  TipoWorkflow: '',
  DhLiberadoEnvio: null,
  DhPeriodoInicio: null,
  DhPeriodoFim: null,
  DhProximaExecucao: null,
  ViewPortX: 0,
  ViewPortY: 0,
  ViewPortZoom: 1
};

export const listKeyValueStatus: IKeyValue[] = [
  {
    key: 'ATIV ',
    value: 'Ativa'
  }, {
    key: 'INAT ',
    value: 'Inativa'
  }, {
    key: 'TEST ',
    value: 'Teste'
  }];

export const listKeyValueTipo: IKeyValue[] = [
  {
    key: 'CJAN ',
    value: 'Com Janela'
  }, {
    key: 'SJAN ',
    value: 'Sem Janela'
  }];

export const listKeyValueTipoEdge: IKeyValue[] = [
  {
    key: 'bezier',
    value: 'bezier'
  }, {
    key: 'smoothstep',
    value: 'smoothstep'
  }, {
    key: 'step',
    value: 'step'
  }, {
    key: 'straight',
    value: 'straight'
  }];


